module.exports = __webpack_public_path__ + "static/img/JOBS.b62dc866.jpg";